import { IPeopleFinderPerson } from '../interfaces/IPeopleFinderPerson';
import { Environment } from './Environment';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

interface ISuggestedPeopleResponse {
  top?: string;
  result: IPeopleFinderPerson[];
}
interface IGetFilterListResponse {
  departments: string[];
  jobTitles: string[];
  locations: string[];
}

interface IGetAllPersonsResponse {
  skipReference: string;
  filter: string;
  top: string;
  result: IPeopleFinderPerson[];
}

interface IGetAdditionalUserInformation {
  skills: string[];
  aboutMe: string;
}

export class PeopleFinderService {
  public async getSuggestedPeople(tenantName: string, top: number, key: string, token: string, environment: 'Development' | 'Test' | 'Production'): Promise<ISuggestedPeopleResponse> {
    const hostName = Environment.getEnvironmentForPeopleFinderAPI(environment);
    const suggestedPeople: ISuggestedPeopleResponse = await new FetchProxy(`${hostName}/${tenantName}/people/${key}/suggested?top=${top}`, {
      method: 'GET',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        authToken: token,
      },
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((response) => {
        if (response.status === 400) {
          return console.log(response);
        }
        if (response.ok) {
          return response.json();
        }
        if (response.status === 500) {
          console.log('Get Suggested People - Server Error');
        }
      })
      .catch((err) => {
        // TODO Handle accordingly
        console.log(err);
      });
    console.warn(suggestedPeople);
    return { ...suggestedPeople };
  }

  public async getProfile(tenantName: string, token: string, environment: 'Development' | 'Test' | 'Production'): Promise<IPeopleFinderPerson> {
    const hostName = Environment.getEnvironmentForPeopleFinderAPI(environment);
    const user: IPeopleFinderPerson = await new FetchProxy(`${hostName}/${tenantName}/people/me`, {
      method: 'GET',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        authToken: token,
      },
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((res: Response) => {
        if (res.status === 400) {
          return console.log(res);
        }
        if (res.status === 500) {
          return console.log('Get Suggested People - Server Error');
        }
        return res.json();
      })
      .catch((err: Error) => {
        // TODO Handle accordingly
        return console.log(err);
      });
    return {
      ...user,
    };
  }

  public async getAdditionalUserInformation(tenantName: string, token: string, environment: 'Development' | 'Test' | 'Production', id: string): Promise<IGetAdditionalUserInformation> {
    const hostName = Environment.getEnvironmentForPeopleFinderAPI(environment);
    const peopleFinderListResponse: IGetAdditionalUserInformation = await new FetchProxy(`${hostName}/${tenantName}/people/id/${id}`, {
      method: 'GET',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        authToken: token,
      },
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((res: Response) => {
        if (res.status === 400) {
          return console.log(res);
        }
        if (res.status === 500) {
          return console.log('Get Suggested People - Server Error');
        }
        return res.json();
      })
      .catch((err: Error) => {
        // TODO Handle accordingly
        console.log(err);
      });
    return { ...peopleFinderListResponse };
  }

  public async getFilteringLists(tenantName: string, token: string, environment: 'Development' | 'Test' | 'Production'): Promise<IGetFilterListResponse> {
    const hostName = Environment.getEnvironmentForPeopleFinderAPI(environment);
    const peopleFinderFilterListResponse: IGetFilterListResponse = await new FetchProxy(`${hostName}/${tenantName}/filterLists`, {
      method: 'GET',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        authToken: token,
      },
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((res: Response) => {
        if (res.status === 400) {
          return console.log(res);
        }
        if (res.status === 500) {
          return console.log('Get Suggested People - Server Error');
        }
        return res.json();
      })
      .catch((err: Error) => {
        // TODO Handle accordingly
        console.log(err);
      });
    return { ...peopleFinderFilterListResponse };
  }

  public async getAllPeople(tenantName: string, token: string, environment: 'Development' | 'Test' | 'Production', filterQuery = '', skip?, top = 12): Promise<IGetAllPersonsResponse> {
    const hostName = Environment.getEnvironmentForPeopleFinderAPI(environment);
    const peopleFinderListResponse: IGetAllPersonsResponse = await new FetchProxy(`${hostName}/${tenantName}/people?filter=${filterQuery}${skip ? `&skip=${skip}` : ''}${top ? `&top=${top}` : ''}`, {
      method: 'GET',
      credentials: 'same-origin',
      mode: 'cors',
      headers: {
        authToken: token,
      },
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((res: Response) => {
        if (res.status === 400) {
          return console.log(res);
        }
        if (res.status === 500) {
          console.log('Internal Server Error');
        }
        return res.json();
      })
      .catch((error: Error) => {
        return console.log(error);
      });
    return { ...peopleFinderListResponse };
  }
}
